/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import TextInput from "../BasicInputs/TextInput.jsx";
import {Database} from "../../APIClient.jsx";
import OutputList from "../OutputList/OutputList.jsx";
import OutputListItem from "../OutputList/OutputListItem.jsx";
import {Util} from "../../Utilities.js";
import {Pages} from "../../Objects/Pages.jsx";
import ButtonComponent from "../BasicInputs/ButtonComponent.jsx";
import ElementDomains from "../ElementDomains.jsx";
import {names} from "../../Constants.js";

class PageSettings extends Component {
    constructor() {
        super();

        this.state = {
            pageInfo: {}
        }
        this.DebouncedSave = Util.performance.debounce((handler, query) => handler(query), 300)

    }


    async fetchData() {
        let {pageId} = this.props
        let page = await Database.table("Pages", "app").simpleFilter("indexKey", pageId)
        this.setState({pageInfo: page?.recordset?.[0] ?? {}})

    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.pageId !== this.props.pageId) {
            this.fetchData()
        }
    }

    onChange(key, value) {
        let {pageInfo} = this.state

        this.setState((state) => {
            let newData = state.pageInfo
            newData[key] = value
            return ({pageInfo: newData})
        }, () => {
            this.DebouncedSave(() => {
                Pages(pageInfo.indexKey).update({[key]: this.state.pageInfo?.[key]})
            })
        })
    }


    render() {
        let {pageInfo} = this.state

        return (
            <div className={"py-2"}>
                <OutputList>
                    <OutputListItem titel={`${names.page} Id`}>
                        <span>{pageInfo.indexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={`${names.page} Domain`}>
                        <span>{pageInfo.domain}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Image Id"}>
                        <span>{pageInfo.imageIndexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Proxy Id"}>
                        <span>{pageInfo?.proxy?.proxyId}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Proxy name"}>
                        <span>{pageInfo?.proxy?.name}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Storage Id"}>
                        <span>{pageInfo?.storage?.storageId}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Storage name"}>
                        <span>{pageInfo?.storage?.name}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Background"}>
                        <span>
                            <TextInput value={(pageInfo?.backgroundURL ?? "").toString()} onChange={(newValue) => {
                                this.onChange("backgroundURL", newValue)
                            }}/>
                        </span>
                    </OutputListItem>
                    <OutputListItem titel={"Delete"}>
                        <span>
                         <ButtonComponent iconName={"IoTrash"}
                                          id={"deletePage"}
                                          text={`Delete ${names.page}`}
                                          onClick={async () => {
                                              await Pages(pageInfo.indexKey).removeDialog("#deletePage")
                                          }}
                         />
                        </span>
                    </OutputListItem>
                    <OutputListItem titel={"Domains"}>
                        <span>
                                       <ElementDomains elementId={pageInfo.indexKey} elementType={"page"}/>

                        </span>
                    </OutputListItem>
                </OutputList>


            </div>
        );
    }
}

PageSettings.propTypes = {};

PageSettings.defaultProps = {};


export default PageSettings;